/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  getTranslation(lang: string): Observable<any> {
    const baseUrl = this.configService.getTranslationsUrl;
    return this.http.get(`${baseUrl}${lang}.json`);
  }
}
